import { JDSDatepickerMonthViewProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerMonthViewProps>
  ): React.FC<JDSDatepickerMonthViewProps> =>
  (props: JDSDatepickerMonthViewProps) => {
    return <Component {...props} />;
  };
